<template>
  <div class="diversity-overtime-stats-wrap">
    <div class="first-row">
      <div class="diversity-score" v-if="statsData.overall">
        <!-- {{Math.round(statsData.overall * 100) / 100}} -->
        {{statsData.overall.toFixed(2)}}
      </div>
      <div class="diversity-score" v-else>
        --
      </div>
      <div class="diversity-sub">
        Overall engagement score in {{user.company_name}}
      </div>
    </div>
    <div class="second-row">
      <div class="diversity-score" v-if="statsData.Male">
        <!-- {{Math.round(statsData.Male * 100) / 100}} -->
        {{statsData.Male.toFixed(2)}}
      </div>
      <div class="diversity-score" v-else>
        --
      </div>
      <div class="diversity-sub">
        Overall engagement score of male
      </div>
    </div>
    <div class="third-row">
      <div class="diversity-score" v-if="statsData.Female">
        <!-- {{Math.round(statsData.Female * 100) / 100}} -->
        {{statsData.Female.toFixed(2)}}
      </div>
      <div class="diversity-score" v-else>
        --
      </div>
      <div class="diversity-sub">
        Overall engagement score of female
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DiversityOvertimeStats',
  props: {
    statsData: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  }
};

</script>

<style lang="scss" scoped>
.diversity-overtime-stats-wrap {
  display: grid;
  grid-template-columns: 1fr;
  padding-left: 20px;
  .first-row, .second-row, .third-row{
    display: grid;
    grid-template-columns: 1.5fr 3fr;
    align-items: center;
    .diversity-score {
      font-size: 50px;
    }
  }
}
</style>
